export default {
  photos: state => state.photos,
  photo: state => state.photo
}
